export const materialUnexposed = {
    backgroundHover: 'rgba(0, 0, 0, 0.13)',
    statesBlackOverlay: 'rgba(0, 0, 0, 0.018)'
};

export const customColor = {};
